import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from "react-router-dom";
import { Breadcrumb, Message, Spin, Card, Row, Col, Modal } from 'antd';
import { User } from "../../../models";
import PageHeaderLayout from '../../../layouts/PageHeaderLayout';
import { Form } from '../../../components';
import styles from './index.less';

const { confirm } = Modal;

const mapStateToProps = state => ({
  currentUser: state.user.current,
  user: state.user,
});

class UserForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.setLoadingFalse();
    if (!this.props.match.params.id) {
      this.props.formReset();
    } else {
      this.props.setCurrentUser(this.props.match.params.id);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.match.params.id && !nextProps.match.params.id) {
      this.props.formReset();
      this.setState({ loading: true }, () => this.setLoadingFalse());
    }
    if (nextProps.match.params.id && (this.props.match.params.id !== nextProps.match.params.id)) {
      this.props.setCurrentUser(this.props.match.params.id);
    }
  }

  setLoadingFalse = () => {
    setTimeout(() => {
      this.setState({ loading: false });
    }, 300);
  }

  handleDelete = async ({ body }) => {
    confirm({
      title: 'Та уг Админыг устгахдаа итгэлтэй байна уу?',
      // content: 'Some descriptions',
      okText: 'Тийм',
      okType: 'danger',
      cancelText: 'Үгүй',
      onOk: async () => {
        await this.props.userDelete({ body });
        Message.success('Админыг амжилттай устгалаа');
        if (!this.props.user.error) this.props.history.push({ pathname: '/users' });
        // console.log('OK', body, this.props.productDelete);
      },
      onCancel: () => {
        console.log('Cancel');
      },
    });
  }

  handleSubmit = async (data) => {
    if (this.props.match.params.id) {
      await this.props.userUpdate({
        body: {
          ...data.formData,
        },
      });
      if (this.props.user.error) {
        Message.error('Админ засах амжилтгүй');
      } else {
        Message.success('Админ амжилттай заслаа');
        this.props.history.push({ pathname: '/users' });
      }
    } else {
      await this.props.userCreate({ body: data.formData });
      // console.log('productCreate works: ', this.props);
      if (this.props.user.error) {
        Message.error('Админ нэмэх амжилтгүй');
      } else {
        Message.success('Админ амжилттай нэмлээ');
        this.props.history.push({ pathname: '/users' });
      }
    }
  }

  loading = () => (
    <div className={styles.loading}>
      <Spin />
    </div>
  )

  breadcrumb = (
    <div className={styles.pageTop}>
      <Breadcrumb className={styles.Topbread}>
        <Breadcrumb.Item><Link to="/">Нүүр</Link></Breadcrumb.Item>
        <Breadcrumb.Item><Link to="/users">Админ</Link></Breadcrumb.Item>
        {
          this.props.match.params.id ? <Breadcrumb.Item>Админ засварлах</Breadcrumb.Item> : <Breadcrumb.Item>Админ нэмэх</Breadcrumb.Item>
        }
      </Breadcrumb>
    </div>
  );

  form = {
    schema: {
      title: 'Form',
      type: 'object',
      required: this.props.match.params.id ? ['name', 'email', 'tel'] : ['name', 'email', 'tel', 'password'],
      column: 12,
      properties: {
        name: {
          type: 'string',
          label: 'Нэр',
        },
        email: {
          type: 'string',
          label: 'И-мэйл',
        },
        password: {
          type: 'string',
          label: 'Нууц үг',
        },
        tel: {
          type: 'number',
          label: 'Утасны дугаар',
        },
        active: {
          type: 'boolean',
          label: 'Идэвхитэй эсэх',
          placeholder: 'Тийм',
        },
      },
    },
    uiSchema: {
      name: {
        'ui:widget': 'input',
        'ui:placeholder': 'Нэр',
      },
      email: {
        'ui:widget': 'email',
        'ui:placeholder': 'И-мэйл',
      },
      password: {
        'ui:widget': 'input',
        'ui:placeholder': 'Нууц үг',
      },
      tel: {
        'ui:widget': 'number',
        'ui:placeholder': 'Утасны дугаар',
      },
      active: {
        'ui:widget': 'switch-active',
      },
    },
  }

  render() {
    return (
      <PageHeaderLayout
        content={this.breadcrumb}
      >
        {
          this.state.loading ?
          this.loading() :
          <Card bordered={false} >
            <Row>
              <Col span={24} className={styles.formCol}>
                <Form
                  form={this.form}
                  data={this.props.currentUser}
                  dataParams={{ body: { id: this.props.match.params.id } }}
                  delete={this.handleDelete}
                  onSubmit={this.handleSubmit}
                  submitButtonName={this.props.match.params.id ? 'Засах' : 'Нэмэх'}
                />
              </Col>
            </Row>
          </Card>
        }
      </PageHeaderLayout>
    );
  }
}

UserForm.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object,
  userDelete: PropTypes.func,
  userCreate: PropTypes.func.isRequired,
  userUpdate: PropTypes.func.isRequired,
  formReset: PropTypes.func.isRequired,
  setCurrentUser: PropTypes.func.isRequired,
  currentUser: PropTypes.object,
  user: PropTypes.object,
};

UserForm.defaultProps = {
  currentUser: undefined,
  userDelete: undefined,
  history: undefined,
  user: undefined,
};


export default connect(mapStateToProps, {
  formReset: User.reset,
  userCreate: User.create,
  userDelete: User.remove,
  userUpdate: User.update,
  setCurrentUser: User.setCurrentUser,
})(UserForm);



// WEBPACK FOOTER //
// ./src/containers/Users/Form/index.js